import { Subdomain } from "src/app/model/enum/observations/subdomain.enum";
import { Domain } from "src/app/model/enum/observations/domain.enum";
import { RubricMasterDTO } from "src/app/model/observation/rubric/rubric-master-dto.model";


export class RubricHelpers {
    
    public static getRubricResponseForDomain(rubric?: RubricMasterDTO, domain?: Domain, userId?: string) {
        const responses = rubric?.rubricResponseMastersDTOs?.filter(r => r.domain === domain) ?? [];
        return responses?.find(r => r.user?.userID === userId);
    }

    public static getRubricResponeForComponent(rubric?: RubricMasterDTO, domain?: Domain, component?: Subdomain, userId?: string) {
        const response = this.getRubricResponseForDomain(rubric, domain, userId);
        return response?.rubricResponsesDTOs?.find(r => r.component === component);
    }

    public static getRubricResponeForComponent_TargetUser(rubric?: RubricMasterDTO, domain?: Domain, component?: Subdomain) {
        return this.getRubricResponeForComponent(rubric, domain, component, rubric?.targetUser?.userID);
    }

    public static getRubricResponeForComponent_EvaluatingUser(rubric?: RubricMasterDTO, domain?: Domain, component?: Subdomain) {
        return this.getRubricResponeForComponent(rubric, domain, component, rubric?.evaluatingUser?.userID);
    }

}